module.exports = __webpack_public_path__ + "static/media/Mockup_bahsegel.bbfab9a8.png";